export default __webpack_public_path__ + "static/media/group-2.6e265079.gif";